import ApiRequestError from "./ApiRequestError";

/**
 * @typedef {Object} ApiCallOptions
 * @property {boolean} prependBaseurl
 */

class Api {
    /**
     * @param {string} baseurl 
     */
    constructor(baseurl) {
        this.baseurl = baseurl;

        /** @type {ApiCallOptions} */
        this._defaultOptions = {
            prependBaseurl: true,
        };
    }

    /**
     * 
     * @param {string} url 
     * @param {ApiCallOptions} [options]
     */
    _get(url, options) {
        return this._fetchJson(url, {
            method: "GET",
            headers: {
                "Accept": "application/json",
            },
        })
    }

    /**
     * 
     * @param {string} url 
     * @param {*} data 
     */
    _post(url, data) {
        return this._fetchJson(url, {
            method: "POST",
            headers: {
                "Accept": "application/json",
                "Content-Type": "application/json;charset=UTF-8",
            },
            body: JSON.stringify(data),
        });
    }

    /**
     * @template T
     * @param {string} endpoint 
     * @param {RequestInit} [init]
     * @param {ApiCallOptions} [options]
     * @returns {Promise<{response: Response, json: T}>}
     */
    _fetchJson(endpoint, init, options) {
        options = options || this._defaultOptions;

        if (options.prependBaseurl)
            endpoint = this.baseurl + endpoint;

        return fetch(endpoint, init)
            .then(response => response.json().then(json => {
                if (!response.ok)
                    throw new ApiRequestError(response, json, `Response has status code ${response.status}`);

                return {
                    response: response,
                    json: json,
                };
            }));
    }
}

export default Api;